"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import type { FC } from "react";
import { HeaderCta, HeaderNavLink } from "./header";
const links = [{
  href: "/blog",
  label: "Blog"
}];
const isActivePath = (pathname: string, href: string): boolean => {
  if (href === "/") {
    return pathname === "/";
  }
  return pathname === href || pathname.startsWith(`${href}/`);
};
export const HeaderNavLinks: FC = () => {
  const $ = _c(10);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = links.map(t1 => {
      const {
        href,
        label
      } = t1;
      return <HeaderNavLink key={href} asChild={true} active={isActivePath(pathname, href)}><Link href={href}>{label}</Link></HeaderNavLink>;
    });
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pathname) {
    t1 = isActivePath(pathname, "/about");
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/about" prefetch={false}>About</Link>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <HeaderCta asChild={true} active={t1}>{t2}</HeaderCta>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t3) {
    t4 = <>{t0}{t3}</>;
    $[7] = t0;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};